<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索和添加 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="请输入商品名称" v-model="searchQuery.title_cn" clearable @clear="handleSearch()" @keyup.enter.native="handleSearch()" size="medium" >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchQuery.status" placeholder="商品状态" @change="handleSearch()" size="medium">
            <el-option v-for="(item, id) in statusMap" :key="id" :label="item.text" :value="Number(id)" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchQuery.category_id" placeholder="商品分类" @change="handleSearch()" size="medium">
            <el-option v-for="item in categoryList" :key="item.category_id" :label="item.name_cn" :value="item.category_id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchQuery.need_addr" placeholder="地址收集" @change="handleSearch()" size="medium">
            <el-option :value="true" label="需要地址"></el-option>
            <el-option :value="false" label="不需要地址"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchQuery.is_deleted" placeholder="是否删除" @change="handleSearch()" size="medium">
            <el-option :value="0" label="有效商品"></el-option>
            <el-option :value="1" label="失效商品"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
          <el-button type="primary" @click="createShop()" size="medium" plain>添加商品</el-button>
        </el-col>
      </el-row>

      <!-- 商品列表 -->
      <el-table :data="shopList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="商品名称" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">{{ scope.row.title_cn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="100" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="库存" width="100" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">{{ scope.row.stock }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销量" width="100" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_deleted === 1 ? 'deleted' : ''">{{ scope.row.sales_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="100" prop="cate_name_cn" align="center"></el-table-column>
        <el-table-column label="商品状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否需要地址" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.need_addr ? 'success' : 'info'">
              {{ scope.row.need_addr ? '需要' : '不需要' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="shopDetail(scope.row.prod_id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import filterMixin from '@/utils/filter.js'

export default {
  name: 'Shops',
  mixins: [filterMixin],
  data() {
    return {
      sessionKey: 'ShopListSearch',
      filterFetchMethod: 'fetchShops',
      shopList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchQuery: {
        title_cn: '',
        status: null,
        need_addr: null,
        is_deleted: 0,
        category_id: null
      },
      statusMap: {
        1: { text: '在售', type: 'success' },
        2: { text: '售罄', type: 'warning' },
        3: { text: '下架', type: 'info' }
      },
      categoryList: []
    }
  },
  created() {
    this.fetchShops()
    this.fetchCategories()
  },
  methods: {
    async fetchShops() {
      try {
        const res = await this.$http.get('shop/search', {
          params: {
            ...this.searchQuery,
            page: this.pageNum,
            size: this.pageSize
          }
        })
        if (!res.success) {
          this.$message.error(res.message)
          return
        }
        this.shopList = res.data
        this.total = res.total
      } catch (err) {
        this.$message.error(err.response?.data?.message || '获取商品列表失败')
      }
    },

    async fetchCategories() {
      try {
        const res = await this.$http.get('shop-cates', {
          params: {
            page: 1,
            size: 100
          }
        })
        if (!res.success) {
          this.$message.error(res.message)
          return
        }
        this.categoryList = res.data
      } catch (err) {
        this.$message.error(err.response?.data?.message || '获取分类列表失败')
      }
    },

    handleSearch() {
      this.pageNum = 1
      this.fetchShops()
    },

    resetSearch() {
      this.searchQuery = { title_cn: '', status: null, need_addr: null, is_deleted: 0, category_id: null }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchShops()
    },

    getStatusText(status) {
      return this.statusMap[status]?.text || '未知状态'
    },

    getStatusType(status) {
      return this.statusMap[status]?.type || ''
    },

    shopDetail(id) {
      this.$router.push(`/admin/shop/details/${id}`)
    },

    createShop() {
      this.$router.push('/admin/shop/create')
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchShops()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchShops()
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.deleted {
  color: #999;
}
</style> 